import { Checkbox } from "@fluentui/react-components";
import type { CheckboxProps } from "@fluentui/react-components";

export const CheckBox = (props: CheckboxProps) => <Checkbox className={props.name} {...props} />;